import { render, staticRenderFns } from "./regionRecords.vue?vue&type=template&id=7a367ee6&scoped=true"
import script from "./regionRecords.vue?vue&type=script&lang=js"
export * from "./regionRecords.vue?vue&type=script&lang=js"
import style0 from "./regionRecords.vue?vue&type=style&index=0&id=7a367ee6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a367ee6",
  null
  
)

export default component.exports